import React, {
  useState,
  useEffect,
} from 'react';
import {
  useDispatch,
} from 'react-redux';

import {
  coreActions,
} from '@gymcloud/core';

import {
  uiActions,
} from 'web-actions';

import {
  Flex,
} from 'web-styled';
import {
  Tabs,
  Pagination,
  ManageVideoUpload,
} from 'web-components';

import Videos from '../Videos';

const tooltipText = {
  search: 'Tip: Paste a YouTube URL to find a specific video',
};

const tabs = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'My Library',
    value: 'mine',
  },
  {
    label: 'Gymcloud',
    value: 'gymcloud',
  },
  {
    label: 'Youtube',
    value: 'youtube',
  },
];

type Props = {
  videos: any[],
  initial: {
    scope?: string,
    query?: string,
  },
  status: any,
  requestMeta: any,
  assignedId?: string,
  assignedText?: string,
  assignButton?: string,
};

const Body = ({
  initial,
  videos,
  status,
  assignedId,
  requestMeta,
  assignedText,
  assignButton,
}: Props) => {
  const dispatch = useDispatch();

  const [isEmpty, setEmpty] = useState(false);
  const [scope, setScope] = useState(initial.scope || 'all');
  const [query, setQuery] = useState(initial.query || '');

  const handleSearch = (page: number) => {
    setEmpty(!query);
    dispatch(
      coreActions.requestSearchVideo({
        q: query,
        page,
        scope,
      }),
    );
  };

  const handleUpload = () => {
    dispatch(
      uiActions.setUiState({
        uploadVideoModal: {
          multiple: false,
          isOpen: true,
        },
      }),
    );
  };

  const handleAssign = (video) => {
    dispatch(
      uiActions.assignSearchVideoModal(video),
    );
  };

  useEffect(() => {
    handleSearch();
  }, [scope]);

  return (
    <Flex
      column
      width="100%"
      spacing={15}
    >
      <ManageVideoUpload
        query={query}
        tooltipText={tooltipText.search}
        onSetQuery={setQuery}
        onSearch={handleSearch}
        onUpload={handleUpload}
      />
      <Tabs
        size="large"
        active={scope}
        onRequestChange={s => setScope(s)}
      >
        {tabs.map(tab => (
          <Videos
            key={tab.value}
            label={tab.label}
            value={tab.value}
            videos={status.succeeded ? videos : []}
            isError={status.failed && !isEmpty}
            isEmpty={status.failed && isEmpty}
            isLoading={status.pending}
            assignedId={assignedId}
            assignedText={assignedText}
            assignButton={assignButton}
            onAssign={handleAssign}
          />
        ))}
      </Tabs>

      <Flex width="100%" justify="center">
        {requestMeta?.total_pages > 1 && (
          <Pagination
            count={requestMeta.total_pages}
            current={requestMeta.page}
            goToPage={handleSearch}
          />
        )}
      </Flex>
    </Flex>
  );
};

Body.defaultProps = {
  assignedId: '',
  assignedText: 'assigned',
  assignButton: 'assign this video',
};

export default Body;
